import Joi from 'joi';

/**
 * Billing payload on tenant update. Trial dates, provider customer ids, and
 * metadata are optional; null is allowed.
 */
export const updateTenantBillingSchema = () =>
  Joi.object({
    enableMetering: Joi.boolean().optional().allow(null),
    meteringProviderCustomerId: Joi.string().max(128).optional().allow(null),
    billingProviderCustomerId: Joi.string().max(128).optional().allow(null),
    trialStartsAt: Joi.string().isoDate().optional().allow(null),
    meteringStartsAt: Joi.string().isoDate().optional().allow(null),
    meteringProviderMetadata: Joi.object().unknown(true).optional().allow(null),
    billingProviderMetadata: Joi.object().unknown(true).optional().allow(null),
  });
